import { PassengerFormData } from '@/root/shared-types/selectTicketPage/selectTicket'

export const createDefaultPassenger = (): PassengerFormData => ({
  firstName: '',
  lastName: '',
  gender: undefined,
  additionalInfo: '',
  citizenship: '',
  birthdate: '',
  personalId: '',
  priceCategory: '',
  personalIdConfirmed: false,
})
